module.exports = __webpack_public_path__ + "dd61d84165e1717f8d8fd41debe0f322.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/magic-staff.png
// module id = 1582
// module chunks = 0